import reduce from 'lodash/reduce';

export const calculateMenuOffset = (sections = [], activeSectionName) => {
  const result = reduce(
    sections,
    (accum, item) => {
      if (accum.hasPassedActiveMenuItem) {
        return accum;
      }

      if (item.name === activeSectionName) {
        return {
          ...accum,
          hasPassedActiveMenuItem: true,
        };
      }

      const width = item?.linkRef?.current?.scrollWidth || 0;

      return {
        hasPassedActiveMenuItem: false,
        offset: accum.offset + width,
      };
    },
    { offset: 0 },
  );

  return result.offset;
};
